var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotBeverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35047 7.40705C1.32134 7.15784 1.30678 7.03324 1.31291 6.93052C1.34504 6.39203 1.74216 5.94579 2.27328 5.85136C2.37459 5.83334 2.50005 5.83334 2.75095 5.83334H8.91544C9.16635 5.83334 9.2918 5.83334 9.39312 5.85136C9.92423 5.94579 10.3214 6.39203 10.3535 6.93052C10.3596 7.03324 10.3451 7.15784 10.3159 7.40705L10.0822 9.40675C9.97671 10.3092 9.49446 11.125 8.75462 11.6525C8.20951 12.0411 7.55672 12.25 6.88724 12.25H4.77915C4.10968 12.25 3.45689 12.0411 2.91177 11.6525C2.17193 11.125 1.68968 10.3092 1.5842 9.40675L1.35047 7.40705Z",
    stroke: "#34265c",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 9.91666H11.0837C12.0502 9.91666 12.8337 9.13315 12.8337 8.16666C12.8337 7.20016 12.0502 6.41666 11.0837 6.41666H10.2087",
    stroke: "#34265c",
    strokeWidth: 0.875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83342 1.16666C5.51126 1.48882 5.51126 2.01116 5.83342 2.33332C6.15559 2.65549 6.15559 3.17782 5.83342 3.49999",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91685 4.37499L2.98459 4.30726C3.28044 4.01141 3.31372 3.54304 3.06269 3.20832C2.81165 2.87361 2.84494 2.40524 3.14079 2.10939L3.20852 2.04166",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45885 4.37499L8.52658 4.30726C8.82243 4.01141 8.85572 3.54304 8.60468 3.20832C8.35364 2.87361 8.38693 2.40524 8.68278 2.10939L8.75051 2.04166",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotBeverage);
export default __webpack_public_path__ + "static/media/HotBeverage.0d267be74a346aeac82711bd7762e2c8.svg";
export { ForwardRef as ReactComponent };